module.exports = __webpack_public_path__ + "static/media/link.503cad02.svg";